import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { translationKeys } from '../../../../../translations';

const CONTACT_NAME_MAX_LENGTH = 100;

type EmergencyNotificationSmsConfigurationContactPersonNameCellProps = InteractiveTableCellProps<string | null>;

export const EmergencyNotificationSmsConfigurationContactPersonNameCell = (
   props: EmergencyNotificationSmsConfigurationContactPersonNameCellProps
): JSX.Element => {
   return (
      <InteractiveTable.TextCell
         defaultValue={props.defaultValue}
         validationRules={{ maxLength: CONTACT_NAME_MAX_LENGTH, required: true }}
         index={props.index}
         name={props.name}
         testId={props.testId}
         placeholder={translationKeys.fillContactName}
      />
   );
};
